var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "title" }, [_vm._v("Claim Airdrop")]),
    _vm._v(" "),
    _c("div", { staticClass: "des" }, [
      _c("b", [_vm._v("Ineligible wallet!")]),
      _vm._v(" This wallet is not eligible for "),
      _c("br"),
      _vm._v(" Airdrop.\n    "),
      _c("span", { on: { click: _vm.init } }, [
        _vm._v("Switch account Check airdrop eligibility."),
      ]),
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _vm._m(1),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "errimg" }, [
      _c("img", {
        attrs: {
          src: require("../assets/images/error.png"),
          alt: "",
          srcset: "",
        },
      }),
      _vm._v(" "),
      _c("p", [_vm._v("Ineligible wallet!")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page_b" }, [
      _vm._v("\n    If you have any questions, please email us at "),
      _c("b", [_vm._v("contact@treasurenet.org")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }